import React from 'react';
import { logError } from '../ErrorLogger';

// ChunkLoadError = старий білд в кеші браузера, новий на сервері
// Рішення: автоматичний reload (один раз)
function handleChunkError(error) {
  if (error && error.name === 'ChunkLoadError') {
    const reloaded = (() => { try { return sessionStorage.getItem('chunk_reload'); } catch { return null; } })();
    if (!reloaded) {
      try { sessionStorage.setItem('chunk_reload', '1'); } catch {}
      window.location.reload(); // reload(true) deprecated — bypass cache handled by server headers
      return true;
    }
  }
  return false;
}

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null, isChunkError: false };
  }

  static getDerivedStateFromError(error) {
    const isChunk = error && error.name === 'ChunkLoadError';
    return { hasError: true, error, isChunkError: isChunk };
  }

  componentDidCatch(error, info) {
    this.setState({ info });

    if (handleChunkError(error)) return; // auto-reload, не логуємо

    logError(error, info?.componentStack?.split('\n')[1]?.trim() || '');
  }

  render() {
    if (this.state.hasError) {
      const { error, info, isChunkError } = this.state;

      // ChunkLoadError — показуємо friendly повідомлення замість debug dump
      if (isChunkError) {
        return (
          <div style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center',
            justifyContent: 'center', minHeight: '60vh', padding: 32,
            fontFamily: 'DM Sans, sans-serif', textAlign: 'center',
            background: 'var(--bv-bg, #fff6e8)',
          }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>🔄</div>
            <h2 style={{ color: 'var(--bv-text, #2a1200)', marginBottom: 8, fontSize: 20 }}>
              New version available
            </h2>
            <p style={{ color: 'var(--bv-text-muted, #8b4e0a)', marginBottom: 24, fontSize: 14, lineHeight: 1.6 }}>
              The app was updated. Please reload to get the latest version.
            </p>
            <button
              onClick={() => { try { sessionStorage.removeItem('chunk_reload'); } catch {} window.location.reload(); }}
              style={{
                background: 'var(--bv-primary, #e8390a)', color: '#fff',
                border: 'none', borderRadius: 12, padding: '12px 28px',
                fontSize: 14, fontWeight: 700, cursor: 'pointer',
                boxShadow: '0 4px 16px rgba(232,57,10,0.3)',
              }}
            >
              Reload App
            </button>
          </div>
        );
      }

      return (
        <div style={{
          padding: '20px', fontFamily: 'monospace', fontSize: '13px',
          background: '#fff3f3', minHeight: '100vh', color: '#333',
        }}>
          <h2 style={{ color: '#cc0000', marginBottom: 12 }}>
            Runtime Error (Debug Mode)
          </h2>

          <div style={{ background: '#fff', border: '2px solid #cc0000', borderRadius: 8, padding: 16, marginBottom: 16 }}>
            <strong>Error:</strong><br />
            <span style={{ color: '#cc0000' }}>{error && error.toString()}</span>
          </div>

          <div style={{ background: '#fff', border: '1px solid #ccc', borderRadius: 8, padding: 16, marginBottom: 16, overflowX: 'auto' }}>
            <strong>Stack Trace:</strong><br />
            <pre style={{ fontSize: 11, whiteSpace: 'pre-wrap', margin: 0 }}>
              {error && error.stack}
            </pre>
          </div>

          {info && (
            <div style={{ background: '#fff', border: '1px solid #ccc', borderRadius: 8, padding: 16, marginBottom: 16, overflowX: 'auto' }}>
              <strong>Component Stack:</strong><br />
              <pre style={{ fontSize: 11, whiteSpace: 'pre-wrap', margin: 0 }}>
                {info.componentStack}
              </pre>
            </div>
          )}

          <button
            onClick={() => window.location.reload()}
            style={{ background: '#cc0000', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 24px', fontSize: 14, cursor: 'pointer' }}
          >
            Reload Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
